import { Link } from 'react-router-dom';
import type { Product } from '../types';
import { canAddToCart, canPreOrder, getPrimaryImage, getProductUrl } from '../utils/product';
import { useCart } from '../context/CartContext';
import { formatPrice } from '../utils/formatPrice';

interface ProductCardProps {
  product: Product;
}

export default function ProductCard({ product }: ProductCardProps) {
  const { addToCart } = useCart();
  const addable = canAddToCart(product);

  return (
    <article className="product-card">
      <Link to={getProductUrl(product.slug)} className="product-image-link">
        <img src={getPrimaryImage(product)} alt={product.name} className="product-image" loading="lazy" />
        {product.images.length > 1 && (
          <span className="image-count-badge">+{product.images.length - 1}</span>
        )}
        {!product.inStock && <span className="out-of-stock-badge">Stokta Yok</span>}
      </Link>

      <div className="product-info">
        <span className="product-category">{product.category}</span>
        <Link to={getProductUrl(product.slug)}>
          <h3 className="product-name">{product.name}</h3>
        </Link>
        <p className="product-price">{formatPrice(product)}</p>
        {product.inStock && product.stock <= 5 && (
          <p className="stock-info stock-low">Son {product.stock} adet</p>
        )}

        {!product.inStock ? (
          canPreOrder(product) ? (
            <Link to={`/on-siparis/${product.slug}`} className="btn btn-outline btn-sm">
              Ön Sipariş Oluştur
            </Link>
          ) : (
            <button className="btn btn-primary btn-sm" disabled>
              Stokta Yok
            </button>
          )
        ) : addable ? (
          <button
            className="btn btn-primary btn-sm"
            onClick={() => addToCart(product)}
          >
            Sepete Ekle
          </button>
        ) : product.priceLabel ? (
          <a href="tel:+905535382462" className="btn btn-outline btn-sm">
            Sipariş Ver
          </a>
        ) : (
          <button className="btn btn-primary btn-sm" disabled>
            Tükendi
          </button>
        )}
      </div>
    </article>
  );
}
